module.exports = __webpack_public_path__ + "static/media/after-block2.df3e3fdd.jpg";